import { FileService } from '../../services'
import * as qiniu from 'qiniu-js'

const FILE_TYPE = {
    Image: 'image',
    File: 'file'
}

interface uploadOption {
    origin?: boolean         // 是否采用原文件名上传，否则采用唯一 key 值作为远程文件名进行上传
}
class UploadImg {
    private file: any
    private putExtra: any = {
        fname: '',   // string，文件原文件名
        params: {},  //object，用来放置自定义变量
        mimeType: null
        //用来限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
    }
    private config: any = {
        useCdnDomain: true,    //表示是否使用 cdn 加速域名
        region: qiniu.region.z2 // 明确指定华南区域（bucket niumedia 在该区域），避免自动探测 api.qiniu.com 导致 DNS 解析失败
    }
    public type: any
    
    constructor(file: any, type: 'image' | 'file' = 'image') {
        this.file = file
        this.type = type
        this.putExtra.fname = file.name
        if (this.type === FILE_TYPE.Image) {
            this.putExtra.mimeType = ['image/png', 'image/jpeg', 'image/jpg']
        }
    }
    
    public async upload({ origin }: uploadOption = { 
        origin: false 
    }): Promise<{ key?: string, error?: boolean }> 
    {
        return new Promise(async (resolve: Function) => {
            const result = await FileService.getToken()
            if (result.status === 200) {
                const { token, key } = result.data as any
                let fileName = origin ? this.file.name : key

                if (this.type === FILE_TYPE.File && this.file.tail) {
                    fileName = key + this.file.tail
                }
                
                const observable = qiniu.upload(this.file, fileName, token, this.putExtra, this.config)
                observable.subscribe({
                    error() { resolve({ error: true }) },
                    next() {},
                    complete(result) { resolve(result) }   
                })
            } else {
                resolve({ error: true })
            }
        })
    }
}

export default UploadImg
